import { useQuery } from 'react-query';
import { ParticipantBrokerAccountSharedService, ParticipantAccountsService } from '../../services/wealthlane-customer-services';

interface BrokerAccount {
  accountsCompanyName?: string | null;
  accountNumber?: string | null;
  accountStatus?: string | null;
  isCurrent?: boolean;
}

const useGetParticipantBrokerAccounts = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
) => {
  const participantBrokerAccounts = useQuery(
    ['getParticipantBrokerAccounts'],
    async () =>
      handleRequest(
        ParticipantAccountsService.getApiCustomerApiAppParticipantAccountsParticipantBrokerAccounts()
      ),
    {
      select(data) {
        return data?.brokerAccounts;
      },
    }
  );
  return participantBrokerAccounts;
};

export default useGetParticipantBrokerAccounts;
